"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withSearchInputHandler = exports.handleSearchInputFocus = exports.makeHandleSearchInputSearch = exports.makeHandleClearSearchTerm = exports.makeHandleSearchInputChange = void 0;

var _recompose = require("@hypnosphi/recompose");

var makeHandleSearchInputChange = function makeHandleSearchInputChange(_ref) {
  var makeSetSearchPhrase = _ref.makeSetSearchPhrase;
  return function (criterions) {
    return function (event) {
      makeSetSearchPhrase(criterions)(event.target.value || '');
    };
  };
};

exports.makeHandleSearchInputChange = makeHandleSearchInputChange;

var makeHandleClearSearchTerm = function makeHandleClearSearchTerm(_ref2) {
  var makeSetSearchPhrase = _ref2.makeSetSearchPhrase,
      hideDetailsMenu = _ref2.hideDetailsMenu;
  return function (criterions) {
    return function () {
      makeSetSearchPhrase(criterions)('');
      hideDetailsMenu();
    };
  };
};

exports.makeHandleClearSearchTerm = makeHandleClearSearchTerm;

var makeHandleSearchInputSearch = function makeHandleSearchInputSearch(_ref3) {
  var searchPhrase = _ref3.searchPhrase,
      makeSetSearchPhrase = _ref3.makeSetSearchPhrase,
      hideDetailsMenu = _ref3.hideDetailsMenu;
  return function (criterions) {
    return function () {
      makeSetSearchPhrase(criterions)(searchPhrase);
      hideDetailsMenu();
    };
  };
};

exports.makeHandleSearchInputSearch = makeHandleSearchInputSearch;

var handleSearchInputFocus = function handleSearchInputFocus(_ref4) {
  var hideDetailsMenu = _ref4.hideDetailsMenu;
  return function () {
    return hideDetailsMenu();
  };
};

exports.handleSearchInputFocus = handleSearchInputFocus;
var withSearchInputHandler = (0, _recompose.withHandlers)({
  makeHandleSearchInputChange: makeHandleSearchInputChange,
  makeHandleClearSearchTerm: makeHandleClearSearchTerm,
  handleSearchInputFocus: handleSearchInputFocus,
  makeHandleSearchInputSearch: makeHandleSearchInputSearch
});
exports.withSearchInputHandler = withSearchInputHandler;
var _default = withSearchInputHandler;
exports["default"] = _default;